<script setup>
import {computed} from "vue";
import store from "../../store";

const props = defineProps({
  withNull: Boolean,
  domesticOnly: Boolean,
  internationalOnly: Boolean
})

const shipping = computed(() => {
  let ship = [...store.state.settings.defaults.shipping]

  if (props.domesticOnly)
    ship = ship.filter((s) => !s.international)
  else if (props.internationalOnly)
    ship = ship.filter((s) => s.international)

  ship = ship.sort((a, b) => {
    return a.carrier.localeCompare(b.carrier);
  }).reduce((acc, s) => {
    if (s.carrier) {
      const index = acc.findIndex(o => o.label === s.carrier)
      if (index === -1)
        acc.push({label: s.carrier, options: [s]})
      else
        acc[index].options.push(s)
    } else
      acc.push(s)

    return acc
  }, [])

  if (props.withNull)
    ship.unshift({value: null, text: '---- None Selected ----'})

  return ship
})

</script>

<template>
  <b-select :options="shipping" size="sm"
            v-bind="$attrs" v-on="$listeners"/>
</template>

<style scoped>

</style>